<rask-selector label="Metod" class="dd-width" [values]="markberedningsalternativ"
    [(ngModel)]="anmalanMarkberedningsmetod"
    [canDelete]="false"
    [disabled]="readonly"
    (change)="metodChanged()">
</rask-selector>